// extracted by mini-css-extract-plugin
module.exports = {"textButton":"TextButton_textButton__3Y0pr"};